"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../configuration");
var AdFormatController = (function () {
    function AdFormatController(mmxl, apiIsOnlineAvailable) {
        this._mmxl = mmxl;
        if (apiIsOnlineAvailable) {
            this.getStandardAdFormats();
        }
        else {
            this.getStandardPrintAdFormats();
        }
    }
    AdFormatController.prototype.getStandardAdFormats = function () {
        var lang = configuration_1.PlanConfiguration.apiLanguage;
        var adFormatPromise = this._mmxl.getStandardAdFormats({ language: lang });
        return adFormatPromise;
    };
    AdFormatController.prototype.getStandardPrintAdFormats = function (kind, norm) {
        if (kind === void 0) { kind = "magazine"; }
        if (norm === void 0) { norm = "standard"; }
        return this._mmxl.getPrintAdFormats(kind, norm);
    };
    AdFormatController.getAdFormat = function (row) {
        if (!_.get(row, "conditions.online.adFormat")) {
            return undefined;
        }
        var theAdFormat = _.get(row, "conditions.online.adFormat");
        return theAdFormat.currentItem;
    };
    AdFormatController.createNullAdformat = function () {
        return { id: "AGOF_Werbeform_0", title: "Keine Werbeform", name: "Keine Werbeform" };
    };
    AdFormatController.getAdformatAdditionalInfoString = function (adFormat) {
        var result = [];
        var additionalInfoStringLength = 3;
        for (var _i = 0, _a = ["exp", "video", "sticky"]; _i < _a.length; _i++) {
            var name_1 = _a[_i];
            if (adFormat[name_1] === true) {
                result.push(name_1.substr(0, additionalInfoStringLength));
            }
        }
        return result.join(",");
    };
    return AdFormatController;
}());
exports.AdFormatController = AdFormatController;
//# sourceMappingURL=adFormatController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/adFormatController.js
// module id = 41
// module chunks = 0